import { act } from 'react';
import {
  GET_SECURITIES,
  GET_SECURITIES_SUCCESS,
  GET_SECURITIES_FAILURE,

  GET_SECURITY,
  GET_SECURITY_SUCCESS,
  GET_SECURITY_FAILURE,
} from './constants';




const intialState = {
  securities: { securities: [], loading: false, loaded: false, error: null },
  security: { security: {}, loading: false, loaded: false, error: null },
}

const Security = (state = intialState, action) => {
  switch (action.type) {
    /* Securities */
    case GET_SECURITIES:
      return {
        ...state,
        securities: { ...state.securities, loading: true, error: null },

      };
    case GET_SECURITIES_SUCCESS:
      return {
        ...state,
        securities: { securities: action.payload, loading: false, loaded: true, error: null },
      };
    case GET_SECURITIES_FAILURE:
      return {
        ...state,
        securities: { ...state.securities, loading: false, loaded: false, error: action.payload },
      };

    /* Security */
    case GET_SECURITY:
      return {
        ...state,
        security: { loading: true, error: null },

      };
    case GET_SECURITY_SUCCESS:
      return {
        ...state,
        security: { security: action.payload, loading: false, loaded: true, error: null },
      };
    case GET_SECURITY_FAILURE:
      return {
        ...state,
        security: { ...state.security, loading: false, loaded: false, error: action.payload },
      };
    default:
      return state;
  }
};

export default Security;
